import React, { Component, Fragment } from "react";
import NuestraRedForm from "./NuestraRedForm";


export class NuestraRed extends Component { 

  render() {
    return (

        <Fragment>

          <NuestraRedForm/>

        </Fragment>

    );
  }
}

export default NuestraRed;
